import type { Types as SduiTypes } from '../types';

export default (
  subject: SduiTypes.subject
): void => {

};
